import { env } from "../config/env";

type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

type ApiOptions = Omit<RequestInit, "headers"> & {
  headers?: Record<string, string>;
};

function buildAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  const token = localStorage.getItem("accessToken");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const tenantId = localStorage.getItem("tenantId") || localStorage.getItem("tenant_id");
  if (tenantId) {
    headers["X-Tenant-ID"] = tenantId;
  }
  return headers;
}

export async function apiRequest<T>(path: string, options?: ApiOptions): Promise<T>;
export async function apiRequest<T>(path: string, method: HttpMethod, data?: unknown): Promise<T>;
export async function apiRequest<T>(
  path: string,
  optionsOrMethod: ApiOptions | HttpMethod = {},
  data?: unknown
): Promise<T> {
  let options: ApiOptions;

  if (typeof optionsOrMethod === "string") {
    const method = optionsOrMethod;
    options = {
      method,
      ...(data !== undefined && method !== "GET" && method !== "DELETE"
        ? { body: JSON.stringify(data) }
        : {}),
    };
  } else {
    options = optionsOrMethod;
  }

  const response = await fetch(`${env.apiBaseUrl}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(),
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json() as Promise<T>;
}
